import { useContext, useState } from 'react';
import { AppContext } from '../ApplicationContext';
import { MessageListToolbar } from "./MessageListToolbar";
import { MessageFactory } from "./MessageFactory";
import { Message, IMessage } from "./Message";
import { DropZone } from "./DropZone";

export interface IMessageListProps {
    messages:IMessage[];
}

export const MessageList = (props : IMessageListProps) => {

   // const context = useContext(AppContext);
    
    //const [messages, setMessages] = useState<IMessage[]>(props.messages);

   //const onReceiveMessage =  (message) => {
   //    
   //    console.log({message:message});
   //    setMessages([...messages,  message])
   //
   //
   //    setTimeout(()=>{
   //         let divElement = document.getElementById('message-list');
   //        // Scroll to the bottom of the div
   //        divElement.scrollTop = divElement.scrollHeight;
   //    }, 25);
   //   
   //
   //};

   setTimeout(()=>{
          let divElement = document.getElementById('message-list');
         // Scroll to the bottom of the div
         divElement.scrollTop = divElement.scrollHeight;

          //let tb = document.querySelector(".mr-message-list-toolbar-content");
          //tb.scrollIntoView();

          //let msg = document.querySelector(".mr-message:last-of-type");
          //msg.scrollIntoView();

      }, 50);

   setTimeout(()=>{
           let divElement = document.getElementById('message-list');
          // Scroll to the bottom of the div
          divElement.scrollTop = divElement.scrollHeight;

          //let tb = document.querySelector(".mr-message-list-toolbar-content");
          //tb.scrollIntoView();
          //let msg = document.querySelector(".mr-message:last-of-type");
          //msg.scrollIntoView();
      }, 1000);

   setTimeout(()=>{
           let divElement = document.getElementById('message-list');
          // Scroll to the bottom of the div
          divElement.scrollTop = divElement.scrollHeight;

          //let tb = document.querySelector(".mr-message-list-toolbar-content");
          //tb.scrollIntoView();
          //let msg = document.querySelector(".mr-message:last-of-type");
          //msg.scrollIntoView();
      }, 1500);




    //context.connection.on("receivemessage", onReceiveMessage);

    //console.log({props:props.messages});
    /*
    if (props.messages.length>0 && messages.length>0 && messages[0].Identifier !== props.messages[0].Identifier) {
        setMessages([...messages,...props.messages]);
    }*/


    const createMessage = (msg: IMessage, index:number) => {
    
        //console.log("Create Message " + msg["$type"], {msg:msg, index:index});

        try {
            //console.log(msg);
            return  MessageFactory[msg["$type"]].create(msg, index);

        } catch(err) {

            console.log("Cannot create Message", {err:err, msg:msg, index:index});

            return  <Message key={index} {...msg}>
                        <div className="alert alert-danger" role="alert">
                            {msg["$type"]} is not yet supported. 
                        </div>
                    </Message>

        }


    }

    return <DropZone>
    
        <div id='message-list' className="mr-message-list" >

            { props.messages.map( createMessage ) }

        </div>

        <MessageListToolbar />
    
    </DropZone>;

}